import React, { useState, useEffect } from "react";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
const moment = extendMoment(originalMoment);

const stateDefinitions = {
  available: {
    color: null,
    label: "Available",
  },
  UAE30001: {
    color: "#FA6800",
    label: "UAE30001",
  },
  KUWAIT30003: {
    color: "#E51400",
    label: "KUWAIT30003",
  },
  MALDIVES30009: {
    color: "#F0A30A",
    label: "MALDIVES30009",
  },
};

const DatePicker = (props) => {
  const {
    customerCode,
    selectedYear,
    setSelectedYear,
    setSelectedDateRange,
    setDatesArray,
  } = props;
  const [value, setValue] = useState(null);
  const [states, setStates] = useState(null);
  const [selectedRange, setSelectedRange] = useState("green");
  // const [selectedDateRange, setSelectedDateRange] = useState(null);
  // const [datesArray, setDatesArray] = useState(null);

  const [dateRanges, setDateRanges] = useState([
    // {
    //   state: 'UAE30001',
    //   range: moment.range(moment('2024-01-20', 'YYYY-MM-DD'), moment('2024-01-27', 'YYYY-MM-DD'))
    // },
    // {
    //   state: 'KUWAIT30003',
    //   range: moment.range(moment('2024-02-01', 'YYYY-MM-DD'), moment('2024-02-16', 'YYYY-MM-DD'))
    // },
    // {
    //   state: 'KUWAIT30003',
    //   range: moment.range(moment('2024-05-23', 'YYYY-MM-DD'), moment('2024-05-26', 'YYYY-MM-DD'))
    // },
    // {
    //   state: 'MALDIVES30009',
    //   range: moment.range(moment('2024-05-08', 'YYYY-MM-DD'), moment('2024-05-12', 'YYYY-MM-DD'))
    // }
  ]);

  const datesFromSession = localStorage.getItem("dateRangesFromSession");
  const datesFromSessionStore = JSON.parse(datesFromSession);

  // useEffect(() => {
  //   if (datesFromSessionStore) {
  //     setDateRanges(Object.keys(datesFromSessionStore).map((obj, index) => ({
  //       state: datesFromSessionStore[obj].custCode,
  //       range: moment.range(moment(obj.split('-')[0], 'MM-DD-YYYY'), moment(obj.split('-')[1], 'MM-DD-YYYY'))
  //     })))
  //   }
  // }, [datesFromSessionStore])

  const [trainingInformation, setTrainingInformation] = useState({});

  const dateRangesEx = () => {
    setDateRanges(
      Object.keys(trainingInformation[selectedYear]).map((obj, index) => ({
        state: trainingInformation[selectedYear][obj].custCode,
        range: moment.range(
          moment(obj.split("-")[0], "MM-DD-YYYY"),
          moment(obj.split("-")[1], "MM-DD-YYYY")
        ),
      }))
    );
    // console.log(dateRanges);
  };

  useEffect(() => {
    if (selectedYear) {
      const plannedEvents = localStorage.getItem("plannedEvent");
      setTrainingInformation(JSON.parse(plannedEvents));
    }
  }, [selectedYear]);

  useEffect(() => {
    if (Object.entries(trainingInformation).length > 0) {
      dateRangesEx();
    }
  }, [trainingInformation, selectedYear]);

  const handleSelect = (range, newStates) => {
    // range is a moment-range object
    setValue(range);
    setStates(newStates);

    setSelectedYear(range.start.format("YYYY"));

    const finalFormat = `${range.start.format("MM/DD/YYYY")}-${range.end.format(
      "MM/DD/YYYY"
    )}`;
    setSelectedDateRange(finalFormat);

    // Calculate in-between dates
    const momentRange = extendMoment(moment).range(range.start, range.end);
    const inBetweenDates = Array.from(momentRange.by("day"));

    // Format in-between dates
    const formattedDates = inBetweenDates.map((date) =>
      date.format("MM/DD/YYYY")
    );
    setDatesArray(formattedDates);
  };

  const dates = [
    moment("2024-01-15", "YYYY-MM-DD"),
    moment("2024-01-27", "YYYY-MM-DD"),
  ];
  const range = moment.range(dates);

  const countryDateRangeColors = {
    UAE30001: { start: new Date(2024 - 1 - 1), end: new Date(2024 - 1 - 15) },
    KUWAIT30003: { start: new Date(2024 - 1 - 16), end: new Date(2024, 1, 31) },
    // Add more country-date range mappings as needed
  };

  // useEffect(() => {
  //   const getSelectedRangeColor = (countryCode) => {
  //     if (states && states.length > 0) {
  //       for (const code in countryDateRangeColors) {
  //         const { start, end, color } = countryDateRangeColors[code];
  //         const range = states[0]?.dateRange;

  //         if (range && range.start >= start && range.end <= end) {
  //           console.log(countryCode)
  //           return code === countryCode ? color : 'gray';
  //         }
  //       }
  //     }

  //     return 'gray';
  //   };
  //   if (states !== null) {
  //     setSelectedRange(getSelectedRangeColor(customerCode));
  //   }
  // }, [states, customerCode])

  const customStyles = {
    calendar: {
      width: "calc(100%/4)",
    },
  };

  // console.log(value, states);

  const initialYear = 2023;
  const initialDate = new Date(initialYear, 1, 1);
  const initialValue = dateRanges[customerCode];

  return (
    <>
      <DateRangePicker
        firstOfWeek={0}
        numberOfCalendars={12}
        selectionType="range"
        minimumDate={new Date("01-01-2024")}
        stateDefinitions={stateDefinitions}
        initialYear={2024}
        dateStates={dateRanges}
        defaultState="available"
        showLegend={false}
        value={value}
        onSelect={handleSelect}
        initialDate={initialDate}
        // ranges={countryDateRangeColors}
        // style={{ background: selectedRange }}
      />
      <style>
        {`.DateRangePicker__PaginationArrow {
      display: none;
    }
    .DateRangePicker__MonthHeader{
    color: #CCBE88;
    text-align:left;
    }
    .DateRangePicker__WeekdayHeading abbr[title] {
      color: #fff;
    }
    .DateRangePicker__Month{
      color: #808080;
      width:300px;
    }
    .DateRangePicker__Date {
      border : none;
    }
    .DateRangePicker__WeekdayHeading{
      border : none;
      text-align: center;
      background: transparent;
    }
    .DateRangePicker__MonthDates{
      border: none;
    }
    .DateRangePicker__Date--weekend{
      background-color: #212529;
    }
    .DateRangePicker__CalendarSelection{
      background-color: ${
        customerCode.customerCode === "UAE30001"
          ? "#FA6800"
          : customerCode.customerCode === "KUWAIT30003"
          ? "#E51400"
          : "#F0A30A"
      };
      border:0px;
    }
    .DateRangePicker__FullDateStates {
      bottom: 0px;
      left: 4px;
      position: absolute;
      right: 4px;
      top: 0px;
      border-radius: 40px;
    }
    .DateRangePicker__HalfDateStates {
      position: static;
      transform: none;
    }
    .DateRangePicker__CalendarDatePeriod--am{
      left: 11%;
      right: 11%;
      border-radius:20px;
    }
    .DateRangePicker__CalendarDatePeriod--pm{
      left: 11%;
      right: 11%;
      border-radius:20px;
    }
    .DateRangePicker {
      display:flex;
      flex-wrap:wrap;
      gap:2rem;
    }
      `}
      </style>
    </>
  );
};

export default DatePicker;
